import { Outlet, Navigate } from "react-router-dom";
import { token } from "../utils/utils";

const UserAuthGuard = () => {
    return token ? <Navigate to="/calender" /> : <Outlet />
};

export default UserAuthGuard;
